import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Sun, Moon } from 'lucide-react';
// Import all investor slides
import { InvestorSlide0 } from '../components/investor-slides/InvestorSlide0';
import { InvestorSlide1 } from '../components/investor-slides/InvestorSlide1';
import { InvestorSlide2 } from '../components/investor-slides/InvestorSlide2';
import { InvestorSlide3 } from '../components/investor-slides/InvestorSlide3';
import { InvestorSlide4 } from '../components/investor-slides/InvestorSlide4';
import { InvestorSlide5 } from '../components/investor-slides/InvestorSlide5';
import { InvestorSlide6 } from '../components/investor-slides/InvestorSlide6';
import { InvestorSlide7 } from '../components/investor-slides/InvestorSlide7';
import { InvestorSlide8 } from '../components/investor-slides/InvestorSlide8';
import { InvestorSlide9 } from '../components/investor-slides/InvestorSlide9';
import { InvestorSlide10 } from '../components/investor-slides/InvestorSlide10';
import { InvestorSlide11 } from '../components/investor-slides/InvestorSlide11';
import { InvestorSlide12 } from '../components/investor-slides/InvestorSlide12';
import { InvestorSlide13 } from '../components/investor-slides/InvestorSlide13';
import { InvestorSlide14 } from '../components/investor-slides/InvestorSlide14';
const slides = [InvestorSlide0, InvestorSlide1, InvestorSlide2, InvestorSlide3, InvestorSlide4, InvestorSlide5, InvestorSlide6, InvestorSlide7, InvestorSlide8, InvestorSlide9, InvestorSlide10, InvestorSlide11, InvestorSlide12, InvestorSlide13, InvestorSlide14];
export function InvestorDeck() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isDark, setIsDark] = useState(false);
  const paginate = (newDirection: number) => {
    const nextSlide = currentSlide + newDirection;
    if (nextSlide >= 0 && nextSlide < slides.length) {
      setDirection(newDirection);
      setCurrentSlide(nextSlide);
    }
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        paginate(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        paginate(-1);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);
  const CurrentSlideComponent = slides[currentSlide];
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <div className={`w-full h-screen overflow-hidden relative font-sans transition-colors duration-300 ${isDark ? 'bg-[#1D3C58] text-white selection:bg-heliona-mint/30' : 'bg-heliona-cream text-heliona-charcoal selection:bg-heliona-mint/30'}`} data-id="element-949">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-950">
        {isDark ? <>
            <div className="absolute top-[-20%] right-[-10%] w-[800px] h-[800px] bg-heliona-mint/5 rounded-full blur-3xl" data-id="element-951" />
            <div className="absolute bottom-[-20%] left-[-10%] w-[600px] h-[600px] bg-heliona-mint/5 rounded-full blur-3xl" data-id="element-952" />
          </> : <>
            <div className="absolute top-[-20%] right-[-10%] w-[800px] h-[800px] bg-heliona-mint/5 rounded-full blur-3xl" data-id="element-953" />
            <div className="absolute bottom-[-20%] left-[-10%] w-[600px] h-[600px] bg-heliona-pastel-blue/30 rounded-full blur-3xl" data-id="element-954" />
          </>}
      </div>

      {/* Header - Show on content slides (not cover) */}
      {currentSlide > 0 && currentSlide < slides.length - 1 && <header className="absolute top-0 left-0 w-full p-8 flex justify-between items-center z-20" data-id="element-955">
          <div className="flex items-center" data-id="element-956">
            <img src={isDark ? 'https://cdn.magicpatterns.com/uploads/siQDa69uZkA61S2PiBLFML/Heliona_Logo_-_Dark.png' : 'https://cdn.magicpatterns.com/uploads/gsWfp7Yqa2Z6SBgP3SbdyL/HELIONA_transparent.png'} alt="Heliona Logo" className="h-8 sm:h-10" data-id="element-957" />
          </div>
          <div className={`text-sm font-medium uppercase tracking-widest ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-958">
            Confidential
          </div>
        </header>}

      {/* Theme Toggle */}
      <motion.div className="absolute z-30" animate={{
      top: currentSlide === 0 ? '2rem' : 'auto',
      bottom: currentSlide === 0 ? 'auto' : '2rem',
      right: '2rem'
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30,
      duration: 0.5
    }} data-id="element-959">
        <button onClick={() => setIsDark(!isDark)} className={`relative flex items-center gap-0.5 px-0.5 py-0.5 rounded-full transition-all duration-300 ${isDark ? 'bg-heliona-navy/80 border border-white/20' : 'bg-white/80 border border-heliona-charcoal/20'} backdrop-blur-sm shadow-lg hover:shadow-xl`} aria-label="Toggle theme" data-id="element-960">
          <div className={`flex items-center justify-center w-7 h-7 rounded-full transition-all duration-300 ${!isDark ? 'bg-heliona-mint text-heliona-navy shadow-md' : 'text-white/40'}`} data-id="element-961">
            <Sun className="w-3.5 h-3.5" data-id="element-962" />
          </div>
          <div className={`flex items-center justify-center w-7 h-7 rounded-full transition-all duration-300 ${isDark ? 'bg-heliona-mint text-heliona-navy shadow-md' : 'text-heliona-charcoal/40'}`} data-id="element-963">
            <Moon className="w-3.5 h-3.5" data-id="element-964" />
          </div>
        </button>
      </motion.div>

      {/* Main Content Area */}
      <main className="relative w-full h-full flex items-center justify-center z-10" data-id="element-965">
        <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-966">
          <motion.div key={currentSlide} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
          x: {
            type: 'spring',
            stiffness: 300,
            damping: 30
          },
          opacity: {
            duration: 0.2
          }
        }} className="absolute w-full h-full" data-id="element-967">
            <CurrentSlideComponent isDark={isDark} data-id="element-968" />
          </motion.div>
        </AnimatePresence>
      </main>

      {/* Navigation Controls */}
      <div className="absolute inset-y-0 left-0 w-24 flex items-center justify-start pl-4 z-20 group" data-id="element-969">
        <button onClick={() => paginate(-1)} disabled={currentSlide === 0} className={`p-3 rounded-full transition-all disabled:opacity-0 disabled:cursor-not-allowed transform -translate-x-4 group-hover:translate-x-0 ${isDark ? 'bg-white/5 text-white/50 hover:bg-white/10 hover:text-white' : 'bg-heliona-charcoal/5 text-heliona-charcoal/50 hover:bg-heliona-charcoal/10 hover:text-heliona-charcoal'}`} data-id="element-970">
          <ChevronLeft className="w-8 h-8" data-id="element-971" />
        </button>
      </div>

      <div className="absolute inset-y-0 right-0 w-24 flex items-center justify-end pr-4 z-20 group" data-id="element-972">
        <button onClick={() => paginate(1)} disabled={currentSlide === slides.length - 1} className={`p-3 rounded-full transition-all disabled:opacity-0 disabled:cursor-not-allowed transform translate-x-4 group-hover:translate-x-0 ${isDark ? 'bg-white/5 text-white/50 hover:bg-white/10 hover:text-white' : 'bg-heliona-charcoal/5 text-heliona-charcoal/50 hover:bg-heliona-charcoal/10 hover:text-heliona-charcoal'}`} data-id="element-973">
          <ChevronRight className="w-8 h-8" data-id="element-974" />
        </button>
      </div>

      {/* Footer / Progress */}
      <footer className="absolute bottom-0 left-0 w-full p-8 flex justify-center items-center z-20" data-id="element-975">
        <div className="flex gap-3" data-id="element-976">
          {slides.map((_, index) => <button key={index} onClick={() => {
          setDirection(index > currentSlide ? 1 : -1);
          setCurrentSlide(index);
        }} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-8 bg-heliona-mint' : isDark ? 'w-2 bg-white/20 hover:bg-white/40' : 'w-2 bg-heliona-charcoal/20 hover:bg-heliona-charcoal/40'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-977" />)}
        </div>
      </footer>
    </div>;
}